<template>
  <div class="rich-text-input">
    <template v-if="options.videos && options.videos.length">
      <object-select-input
        v-model="selectedVideo"
        :options="{
          fullWidth: true,
          label: 'Add Video (Optional)',
          objects: options.videos,
          objectName: 'name'
        }">
      </object-select-input>
      <template v-if="selectedVideo">
        <p class="text-muted">
          <i class="fa fa-exclamation-triangle"></i> Place cursor where you want video to be inserted.
        </p>
        <button class="btn btn-pink mb-2" @click.prevent="addVideo()">
          <i class="fa fa-video"></i> Click To Add Video At Cursor
        </button>
      </template>
    </template>
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.index || options.index === 0 ? options.name + options.index : options.name"
        :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <textarea class="form-control" type="text"
          :id="options.index || options.index === 0 ? options.name + options.index : options.name"
          @input="validate($event.target.value)"
          :value="value"
          :name="options.index || options.index === 0 ? options.name + options.index : options.name"
          ref="richInput">
        </textarea>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import ObjectSelectInput from '@/components/inputs/ObjectSelectInput'
  import Api from '@/vuex/api'
  import {
    S3_BUCKET_URL,
    validationClass,
    validationMessage
  } from '@/util/helpers'

  export default {
    name: 'RichTextInput',
    props: {
      value: {
        type: String
      },
      options: {
        type: Object,
        default () {
          return {
            value: '',
            valid: false,
            dirty: false
          }
        }
      }
    },
    components: {
      ObjectSelectInput
    },
    computed: {
      validationClass,
      validationMessage,
      invalidMessage () {
        return this.options.label + ' is required'
      }
    },
    data () {
      return {
        S3_BUCKET_URL: S3_BUCKET_URL,
        isLength: false,
        isRegex: false,
        selectedVideo: '',
        isValid: false,
        isDirty: false,
        minLength: 3,
        name: 'tinymceinput',
        editor: ''
      }
    },
    updated () {
      if (this.editor && this.editor.getContent() !== this.value && this.value) {
        this.editor.setContent(this.value)
      }
    },
    mounted () {
      if (this.options.index || this.options.index === 0) {
        this.name = this.options.name + this.options.index
      } else {
        this.name = this.options.name
      }
      if (tinymce.get(`${this.name}`)) {
        tinymce.get(`${this.name}`).remove()
      }
      tinymce.init({
        selector: `#${this.name}`,
        content_style: '.mce-item-table, .mce-item-table td, .mce-item-table th, .mce-item-table caption { border: none; }',
        height: this.options.height || 450,
        menubar: true,
        statusbar: false,
        browser_spellcheck: true,
        plugins: [
          'code advlist autolink lists link image charmap print preview anchor',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime table paste code help wordcount'
        ],
        toolbar: 'insert | copy paste | undo redo | formatselect fontsizeselect | bold italic underline forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | code help'
      })
      this.editor = tinymce.get(`${this.name}`)
      this.editor.on('change', (e) => {
        this.validate()
      })
    },
    methods: {
      addVideo () {
        let video = this.options.videos.find(el => el.uuid === this.selectedVideo)
        let text = `
        <div style="text-align: center;">
          <a style="text-align: center;" href="${video.url}" target="_blank" rel="noopener">
            <img style="width: 100%; height: auto;" title="${video.name}" src="${S3_BUCKET_URL}${video.PreviewImage.objectKey}" alt="${video.name}" />
          </a>
        </div>`
        this.editor.execCommand('mceInsertContent', false, text)
      },
      validate (value) {
        this.editor.save()
        let val = this.$refs.richInput.value
        if (value) val = value
        this.$emit('input', val)
        this.isDirty = true
        if (val) {
          this.isLength = this.isValid = val.length >= this.minLength
        } else if (this.options.required) {
          this.isValid = false
        } else {
          this.isValid = true
        }
      },
      async updateQuotePdfText (val) {
        let instance = new Api()
        let reportPdfText = await instance.getQuotePdfText(val)
        this.editor.setContent(reportPdfText)
        this.validate(reportPdfText)
      },
      updateContent (val) {
        this.editor.setContent(val)
        this.validate(val)
      },
      runWatcher (val, name) {
        if (this.options.watchers.includes(name)) {
          if (!this.value) this.watcher = true
          if (this.watcher) {
            if (val) {
              switch (name) {
                case 'QuoteTypeUuid':
                  this.updateQuotePdfText(val)
                  break
              }
            } else {
              this.validate('')
              this.isDirty = false
            }
          }
          this.watcher = true
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/RichTextInput.vue